import React from "react";
import BasePage from "../base/BasePage";
import NavBar1 from "../components/Navbar1";
import BISPresenter from "./BISPresenter";
import HeroBmiSection from "./components/HeroBisSection";
import FooterSection from "./components/FooterSection";
import BISSystemOverviewSection from "./components/BISSystemOverviewSection";
import KeyBenefitsSection from "./components/KeyBenefitsSection";
import EndToEndProcessFlowSection from "./components/EndToEndProcessFlowSection";
import ImplementationSuccessSection from "./components/ImplementationSuccessSection";
import CTABisSection from "./components/CTABisSection";
import DemoRequestModal from "./components/DemoRequestModal";
import "./BISPage.css";

class BISPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new BISPresenter();
  }

  render() {
    const heroContent = this.presenter.getHeroSectionContent();
    const footerText = this.presenter.getFooterContent().text;
    const modules = this.presenter.getOverviewModules();
    const benefits = this.presenter.getKeyBenefits();
    const implementationStats = this.presenter.getImplementationStats();

    return (
      <>
        <NavBar1 className="shadow-sm" />
        <HeroBmiSection heroContent={heroContent} />
        <BISSystemOverviewSection modules={modules} />
        <KeyBenefitsSection benefits={benefits} />
        <EndToEndProcessFlowSection />
        <ImplementationSuccessSection stats={implementationStats} />
        <CTABisSection />
        <FooterSection footerText={footerText} />
        <DemoRequestModal />
      </>
    );
  }
}

export default BISPage;
